import React from "react";

const cards = [
  { key: "totalSessions", label: "Total Sessions" },
  { key: "activeSessions", label: "Active Sessions" },
  { key: "scheduledPaidSessions", label: "Scheduled & Paid" },
  { key: "completedPaidSessions", label: "Completed & Paid" },
  { key: "cancelledSessions", label: "Cancelled Sessions" },
  { key: "unbookedSlots", label: "Unbooked Sessions" },
];

function TherapistStatsOverview({ stats }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 mb-6">
      {cards.map((card) => (
        <div key={card.key} className="rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
          <p className="text-xs text-gray-500 mb-2">{card.label}</p>
          <p className="text-2xl font-semibold text-gray-900">{stats?.[card.key] ?? 0}</p>
        </div>
      ))}
    </div>
  );
}

export default TherapistStatsOverview;
